import IntlTextComponent from './IntlTextComponent';

export default IntlTextComponent;
